export default __webpack_public_path__ + "static/media/Phone.8eae8faf.png";